import { Route, Routes } from 'react-router';

import Layout from './components/layout/Layout';
import ScrollToTop from './components/layout/ScrollToTop';
import BlogPage from './components/pages/BlogPage';
import BlogPostPage from './components/pages/BlogPostPage';
import InvitePage from './components/pages/InvitePage';
import MagicLinkRedirectPage from './components/pages/MagicLinkRedirectPage';
import NotFoundPage from './components/pages/NotFoundPage';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import ProductDetailPage from './components/pages/ProductDetailPage';
import RefundPolicy from './components/pages/RefundPolicy';
import TermsOfService from './components/pages/TermsOfService';
import PreOrderPopup from './components/PreOrderPopup';
import AboutSection from './components/sections/AboutSection';
import AdvisorsSection from './components/sections/AdvisorsSection';
import AppSection from './components/sections/AppSection';
import BlogSection from './components/sections/BlogSection';
import FAQSection from './components/sections/FAQSection';
import FeaturedProductsSection from './components/sections/FeaturedProductsSection';
import HeroSection from './components/sections/HeroSection';
import ProductsSection from './components/sections/ProductsSection';
import TeamSection from './components/sections/TeamSection';
import TestimonialsSection from './components/sections/TestimonialsSection';
import { ContactPage } from './features/contact';

function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/products/:slug" element={<ProductDetailPage />} />
        <Route
          path="/auth/verify-magic-link/:token"
          element={<MagicLinkRedirectPage />}
        />
        <Route path="/i/:code" element={<InvitePage />} />
        <Route path="/wisdom" element={<BlogPage />} />
        <Route path="/wisdom/:slug" element={<BlogPostPage />} />
        {import.meta.env.VITE_ENABLE_COMMUNITY_PAGE === 'true' && (
          <Route path="/joincommunity" element={<ContactPage />} />
        )}
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <AboutSection />
              <AppSection />
              {/* <ProductCategoriesGrid /> */}
              <ProductsSection />
              <FeaturedProductsSection />
              <TestimonialsSection />
              <BlogSection />
              <TeamSection />
              <AdvisorsSection />
              <FAQSection />
            </>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <PreOrderPopup />
    </Layout>
  );
}

export default App;
